import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { ETransportType } from 'shared/types/newbuildingOffersCarousel';

import * as styles from './styles.css';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export function FromUndergroundTime({ transportType, timeTo }: IFromUndergroundProps) {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapCar16;

  return (
    <div className={styles['distance']} data-testid="from_underground_time">
      <div className={styles['icon']}>
        <Icon data-testid={`from_underground_time_icon_${transportType}`} color="icon-secondary-default" />
      </div>
      <UIText2 color={'text-secondary-default'}>{`${timeTo}.`}</UIText2>
    </div>
  );
}
